export default function Footer() {
  return (
    <div className='bf-footer'>
      <a href='https://nghcprivacy.com/nationalgeneral/privacy' target='_blank' rel='noreferrer'>Privacy</a>
      &nbsp;|&nbsp;
      <a href='https://nghcprivacy.com/nationalgeneral/onlineprivacystatement#infocollection' target='_blank' rel='noreferrer'>CA Privacy</a>
    </div>
  );
}
